import type { RouteRecordRaw, Router } from 'vue-router';

import { WebLocale } from '@/enums/web-locale';
import { PageType } from '@/routing/config';
import { CollectionType } from '@/enums/collection-type';
import { JWTV_LAUNCH_COUNTRIES } from '@/features/jwtv/config';

const JWTV_LANDING_PAGE_ROUTE = 'app.jwtv.landing-page';

/** The JWTV watch page, null outside the JWTV launch countries where it has no route. */
export function getJwtvWatchPageHref(router: Router): string | null {
	return router.hasRoute(JWTV_LANDING_PAGE_ROUTE) ? router.resolve({ name: JWTV_LANDING_PAGE_ROUTE }).href : null;
}

export function makeRentalListRoutes(currentLocale: WebLocale): RouteRecordRaw[] {
	const routes: RouteRecordRaw[] = [];

	if (JWTV_LAUNCH_COUNTRIES.includes(currentLocale)) {
		routes.push(makeJwtvLPRoute(currentLocale as WebLocale));
	}

	return routes;
}

function makeJwtvLPRoute(currentLocale: WebLocale): RouteRecordRaw {
	return {
		name: JWTV_LANDING_PAGE_ROUTE,
		path: `/${currentLocale}/justwatch-tv`,
		component: () => import('@/pages/landing-pages/jwtv/JWTVLP.vue'),
		meta: {
			tab: 'watch',
			pageType: PageType.WATCH,
			collectionType: CollectionType.JWTV_WATCH_PAGE,
		},
	};
}
